// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kbll","content":"styles_content__2y2Vp"};